import CommentData from '../../../../types/commentData';
import CommentInOverview from '../../../molecules/comment/CommentInOverview';
import CommentForm from '../../../molecules/comment-form/CommentForm';

import './DiscussionQuestionsSidebarContent.scss';
import { useEffect } from 'react';

interface DiscussionQuestionsSidebarContentProps {
  comments: CommentData[];
  onAddComment: (commentBody: string, isAnonymous: boolean) => void;
  onClickComment?: (comment: CommentData) => void;
}

export default function DiscussionQuestionsSidebarContent({
  comments,
  onAddComment,
  onClickComment,
}: DiscussionQuestionsSidebarContentProps) {
  const topLevelComments = comments.filter(comment => comment.topLevelCommentId === null);

  useEffect(() => {}, []);

  const Questions = topLevelComments.map(tlComment => {
    const answers = comments.filter(comment => comment.topLevelCommentId === tlComment.id).length;
    return (
      <button key={tlComment.id} className="block" id={tlComment.id} onClick={() => onClickComment?.(tlComment)}>
        <CommentInOverview className="mb-2" comment={tlComment} answers={answers} />
      </button>
    );
  });

  return (
    <div className="discussion-questions-sidebar-content p-6">
      {Questions.length < 1 ? (
        <div className="empty-discussion">
          <h2 className="headline">No questions asked, yet.</h2>
          <p className="subheading">Get the discussion going by asking a question!</p>
        </div>
      ) : (
        <>
          <p className="text-medium mb-4">Questions</p>
          <div className="discussion-content mb-4">{Questions}</div>
        </>
      )}
      <CommentForm onSend={onAddComment} placeholder="Ask a question" />
    </div>
  );
}
